import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const RevenueSection = ({ formData, handleInputChange, errors }) => {
  const months = [
    'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
  ];

  const calculateAverageRevenue = () => {
    const revenues = formData?.monthlyRevenue || {};
    const values = Object.values(revenues)?.filter(v => v && !isNaN(v));
    if (values?.length === 0) return 0;
    const sum = values?.reduce((acc, val) => acc + parseFloat(val), 0);
    return (sum / values?.length)?.toFixed(0);
  };

  const calculateTotalRevenue = () => {
    const revenues = formData?.monthlyRevenue || {};
    const values = Object.values(revenues)?.filter(v => v && !isNaN(v));
    return values?.reduce((acc, val) => acc + parseFloat(val), 0)?.toFixed(0);
  };

  return (
    <div className="card">
      <div className="flex items-start gap-4 mb-6">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="TrendingUp" size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h2 className="text-2xl md:text-3xl font-semibold mb-2">Pendapatan Bulanan</h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Masukkan data pendapatan bulanan untuk analisis tren dan proyeksi keuangan
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-6">
        {months?.map((month, index) => (
          <Input
            key={month}
            label={month}
            type="number"
            placeholder="0"
            value={formData?.monthlyRevenue?.[month] || ''}
            onChange={(e) => handleInputChange('monthlyRevenue', month, e?.target?.value)}
            error={errors?.[`monthlyRevenue.${month}`]}
            className="w-full"
          />
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 md:p-6 bg-muted rounded-lg">
        <div className="flex items-center justify-between p-4 bg-card rounded-lg">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Rata-rata Bulanan</p>
            <p className="text-xl md:text-2xl font-bold data-text">
              Rp {parseFloat(calculateAverageRevenue())?.toLocaleString('id-ID')}
            </p>
          </div>
          <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="Calculator" size={20} color="var(--color-success)" />
          </div>
        </div>

        <div className="flex items-center justify-between p-4 bg-card rounded-lg">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Total Tahunan</p>
            <p className="text-xl md:text-2xl font-bold data-text">
              Rp {parseFloat(calculateTotalRevenue())?.toLocaleString('id-ID')}
            </p>
          </div>
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Wallet" size={20} color="var(--color-primary)" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueSection;